<template>
  <div class="xieyiCenter clearfix">
    <div class="aa">
      <ui-navigation></ui-navigation>
    </div>
    <div class="aboutBox">
      <div class="info">
        <h3 class="mb-4">用户注册协议</h3>
        <hr class="mb-4">
        <p>本协议是您与雪帝网站(简称"本站")，所有者(以下简称为"雪帝")之间就雪帝网站服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击"提交支付"按钮后，本协议即构成对双方有约束力的法律文件。</p>
        <p>第1条 本站服务条款的确认和接纳</p>
        <p>&nbsp;&nbsp;&nbsp; 1.1 本站的各项电子服务的所有权和运作权归雪帝所有。用户同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</p>
        <p>&nbsp;&nbsp;&nbsp; 1.2 用户点击同意本协议的，即视为用户确认自己具有享受本站服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。</p>
        <p>&nbsp;&nbsp;&nbsp; 1.3 如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用本站。</p>
        <p>&nbsp;&nbsp;&nbsp; 1.4 雪帝保留在中华人民共和国施行之法律（为本协议之目的，不包括香港、澳门和台湾地区的法律）允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。</p>
        <p>第2条 本站服务</p>
        <p>&nbsp;&nbsp;&nbsp; 2.1 雪帝通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。</p>
        <p>&nbsp;&nbsp;&nbsp; 2.2 用户必须自行准备如下设备和承担如下开支：(1)上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置;(2)上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</p>
        <p>&nbsp;&nbsp;&nbsp; 2.3 用户在此知悉，雪帝已提示用户以下内容：建议使用正版操作系统安装及使用本站出售商品；不建议用户将本站出售商品与其他盗版软件一起使用。</p>
        <p>第3条 用户信息</p>
        <p>&nbsp;&nbsp;&nbsp; 3.1 用户应自行诚信向本站提供资料，提交支付成功后会使用用户的手机号码为用户自动创建雪帝账号，创建成功后会发送邮件通知用户。用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且雪帝保留终止用户使用雪帝各项服务的权利。</p>
        <p>&nbsp;&nbsp;&nbsp; 3.2 用户在本站进行浏览、下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。</p>
        <p>&nbsp;&nbsp;&nbsp; 3.3 用户注册成功后，将产生用户名和密码等账户信息，用户可以根据本站规定改变密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。</p>
        <p>&nbsp;&nbsp;&nbsp; 3.4 用户同意，雪帝拥有通过邮件、短信电话等形式，向在本站注册、购物用户、收货人发送订单信息、促销活动等告知信息的权利。</p>
        <p>&nbsp;&nbsp;&nbsp; 3.5 用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。</p>
        <p>&nbsp;&nbsp;&nbsp; 3.6 用户同意，雪帝有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</p>
        <p>&nbsp;&nbsp;&nbsp; 3.7 用户同意，在雪帝规定的范围内，合理使用雪帝提供的各项优惠福利，包括但不限于：新用户专享优惠、指定商品优惠、活动期间优惠、全场通用优惠等。各项优惠权益最终解释权归雪帝所有。</p>
        <p>第4条 用户依法言行义务</p>
        <p>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
        <p>&nbsp;&nbsp;&nbsp; (1)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论;</p>
        <p>&nbsp;&nbsp;&nbsp; (2)从中国大陆向境外传输资料信息时必须符合中国有关法规;</p>
        <p>&nbsp;&nbsp;&nbsp; (3)不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动;</p>
        <p>&nbsp;&nbsp;&nbsp; (4)不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统;</p>
        <p>&nbsp;&nbsp;&nbsp; (5)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料;</p>
        <p>&nbsp;&nbsp;&nbsp; (6)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论;</p>
        <p>&nbsp;&nbsp;&nbsp; (7)不得教唆他人从事本条所禁止的行为;</p>
        <p>&nbsp;&nbsp;&nbsp; (8)不得利用在本站注册的账户进行牟利性经营活动;</p>
        <p>&nbsp;&nbsp;&nbsp; (9)不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容;</p>
        <p>用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。</p>
        <p>本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。</p>
        <p>若用户未遵守以上规定的，本站有权做出独立判断并采取暂停或关闭用户账号等措施。用户须对自己在网上的言论和行为承担法律责任。</p>
        <p>第5条 商品信息</p>
        <p>&nbsp;&nbsp;&nbsp; 5.1 本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证用户所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形用户知悉并理解;雪帝欢迎纠错，并会视情况给予纠错者一定的奖励。</p>
        <p>为表述便利，商品和服务简称为"商品"或"货物"。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.2 根据《中华人民共和国消费者权益保护法》第三章第二十五条、《网络购买商品七日无理由退货暂行办法》第二章第六条规定，本站所销售商品不适用七日无理由退货规定。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.3 鉴于市面主流操作系统为windows操作系统和MAC OS操作系统，用户在购买时请自行确认所购商品是否符合需要，一旦售出，本站将认为用户所购买商品为用户所需要商品。针对永久授权的软件，仅是在其支持的操作系统上可以一直使用。重大更新和功能需要额外收费。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.4 产品换机和安装设备数以产品网站技术参数描述为准，如果没有特殊说明的情况下，雪帝商城所售软件均为一码一机，用户在收到激活码或注册码时，只能在用户指定的一台电脑上安装激活。<b>用户拥有对应购买商品数量的使用权，但未经版权所有者的书面许可，严禁任何人或公司将购买商品提供给第三方，包括但不限于租赁、借出或再销售。</b>
        </p>
        <p>&nbsp;&nbsp;&nbsp; 5.5 雪帝商城不定期会进行活动促销，促销时雪帝商城将注明赠送的软件，雪帝不承诺对该等赠送的软件提供持续服务，包括但不限于软件升级、软件维护、终身授权等。针对参与优惠券/优惠码活动的产品，如用户未使用优惠券/优惠码购买属用户个人购买行为，后续不给予任何形式上的补偿。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.6 雪帝商城所有赠送的模板素材不可作为商业用途使用。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.7 划线价说明：商品展示的划横线价格为参考价，并非原价，该价格可能是由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在本站上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，划线价可能会与您购物时展示的不一致，该价格仅供您参考。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.8 折扣说明：如无特殊说明，折扣指本站在原价、或划线价（如厂商指导价、厂商建议零售价）等某一价格基础上计算出的优惠比例或优惠金额；如有疑问，您可在购买前联系客服进行咨询。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.9 异常问题说明：商品促销信息以商品详情页“促销”栏中的信息为准；商品的具体售价以订单结算页价格为准；如您发现活动商品售价或促销信息有异常，建议购买前先联系客服咨询。</p>
        <p>&nbsp;&nbsp;&nbsp; 5.10 售后服务说明：本站所售商品（除远程服务外）在授权时长内<b>享受自购买之日起开始计算最长一年免费售后服务</b>，授权时长不满一年的，售后服务时长与授权时长一致。</p>
        <p>第6条 订单</p>
        <p>&nbsp;&nbsp;&nbsp; 6.1 在用户下订单时，用户已仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。
        </p>
        <p>&nbsp;&nbsp;&nbsp; 6.2 除法律另有强制性规定外，双方约定如下：本站上销售方展示的商品和价格等信息仅仅是交易信息的发布，用户下单时须填写希望购买的商品数量及支付方式、收货人、联系方式、收货地址等内容;系统生成的订单信息是计算机信息系统根据用户填写的内容自动生成的数据，仅是用户向销售方发出的交易诉求;销售方收到订单信息后，只有在销售方将订单中订购的商品从仓库实际直接向用户发出时(以商品出库为标志)，方视为用户与销售方之间就实际直接向您发出的商品建立了交易关系;如果用户在一份订单里订购了多种商品并且销售方只给用户发出了部分商品时，用户与销售方之间仅就实际直接向用户发出的商品建立了交易关系;只有在销售方实际直接向用户发出了订单中订购的其他商品时，用户和销售方之间就订单中该其他已实际直接向用户发出的商品才成立交易关系。用户可以随时登录其在本站注册的账户，查询订单状态。</p>
        <p>&nbsp;&nbsp;&nbsp; 6.3 由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证用户提交的订单信息中希望购买的商品都会有货;如用户拟购买的商品发生缺货，用户有权取消订单。</p>
        <p>第7条 配送</p>
        <p>&nbsp;&nbsp;&nbsp; 7.1 销售方将会把商品(货物)送到用户所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。</p>
        <p>&nbsp;&nbsp;&nbsp; 7.2 如因以下情况造成订单延迟或无法配送等，销售方不承担延迟配送的责任：</p>
        <p>&nbsp;&nbsp;&nbsp; (1)用户提供的信息错误、地址不详细等原因导致的;</p>
        <p>&nbsp;&nbsp;&nbsp; (2)货物送达后无人签收，导致无法配送或延迟配送的;</p>
        <p>&nbsp;&nbsp;&nbsp; (3)情势变更因素导致的;</p>
        <p>&nbsp;&nbsp;&nbsp; (4)不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</p>
        <p>第8条 所有权及知识产权条款</p>
        <p>&nbsp;&nbsp;&nbsp; 8.1 用户一旦接受本协议，即表明该用户主动将其在任何时间段在本站发表的任何形式的信息内容(包括但不限于客户评价、客户咨询、各类话题文章等信息内容)的财产性权利等任何可转让的权利，如著作权财产权(包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利)，全部独家且不可撤销地转让给雪帝所有，用户同意雪帝有权就任何主体侵权而单独提起诉讼。</p>
        <p>&nbsp;&nbsp;&nbsp; 8.2 本协议已经构成《中华人民共和国著作权法》第二十五条(条文序号依照2011年版著作权法确定)及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在雪帝网站上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
        <p>&nbsp;&nbsp;&nbsp; 8.3 用户同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其它主体以任何方式使用(包括但不限于在各类网站、媒体上使用)。</p>
        <p>&nbsp;&nbsp;&nbsp; 8.4 雪帝是本站的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知用户。在法律允许的最大限度范围内，雪帝对本协议及本站内容拥有解释权。</p>
        <p>&nbsp;&nbsp;&nbsp; 8.5 除法律另有强制性规定外，未经雪帝明确的书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，雪帝有权追究其法律责任。</p>
        <p>&nbsp;&nbsp;&nbsp; 8.6 本站所刊登的资料信息(诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件)，均是雪帝或其内容提供者的财产，受中国和国际版权法的保护。本站上所有内容的汇编是雪帝的排他财产，受中国和国际版权法的保护。本站上所有软件都是雪帝或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</p>
        <p>第9条 责任限制及不承诺担保</p>
        <p>&nbsp;&nbsp;&nbsp; 9.1 除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品(包括软件)和服务，均是在"按现状"和"按现有"的基础上提供的。</p>
        <p>&nbsp;&nbsp;&nbsp; 9.2 除非另有明确的书面说明,雪帝不对本站的运营及其包含在本网站上的信息、内容、材料、产品(包括软件)或服务作任何形式的、明示或默示的声明或担保(根据中华人民共和国法律另有规定的以外)。</p>
        <p>&nbsp;&nbsp;&nbsp; 9.3 雪帝不担保本站所包含的或以其它方式通过本站提供给用户的全部信息、内容、材料、产品(包括软件)和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。</p>
        <p>&nbsp;&nbsp;&nbsp; 9.4 如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，雪帝会合理地尽力协助处理善后事宜。</p>
        <p>&nbsp;&nbsp;&nbsp; 9.5 用户知晓雪帝仅提供现有的成品产品（软件）及相关的信息、内容、材料及服务，但不负责软件的开发、运营及维护、更新工作，用户同意雪帝对此无需承担责任。用户在购买、使用前，应当了解并确认产品（软件）的厂商及厂商提供的售后政策能否满足自身需求，包括是否会进行版本更新、终身维护等。</p>
        <p>&nbsp;&nbsp;&nbsp; 9.6 本合同所涉软件在提供后，因软件及相关信息、内容、材料等更新、维护问题或者因更新、维护不及时而导致用户产生的损失，由提供软件及相关信息、内容、材料的厂商对此进行负责，用户同意雪帝无需对此承担责任。</p>
        <p>&nbsp;&nbsp;&nbsp; 9.7 雪帝会根据情况协助用户与厂商进行联系、沟通，但对最终的结果，以厂商的政策、答复为准，雪帝不做任何承诺和保证。</p>
        <p>第10条 协议更新及用户关注义务</p>
        <p>根据国家法律法规变化及网站运营需要，雪帝有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议; 用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受雪帝网站依据本协议提供的服务;如用户继续使用本网站提供的服务的，即视为同意更新后的协议。用户确认在使用本站之前已有充分时间阅读本协议及本站的公告。 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
        <p>第11条 法律管辖和适用</p>
        <p>本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国适用之有效法律(但不包括其冲突法规则)。 </p>
        <p>如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。 </p>
        <p>如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决;协商不成时，任何一方均可向雪帝所在地的中华人民共和国法院提起诉讼。</p>
        <p>第12条 其他</p>
        <p>&nbsp;&nbsp;&nbsp; 12.1 雪帝网站所有者是指在政府部门依法许可或备案的雪帝网站经营主体。</p>
        <p>&nbsp;&nbsp;&nbsp; 12.2 雪帝尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，雪帝将虚心接受并适时修改本协议及本站上的各类规则。</p>
        <p>&nbsp;&nbsp;&nbsp; 12.3 本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。</p>
        <p>&nbsp;&nbsp;&nbsp; 12.4 点击本协议上方的"提交支付"按钮即视为完全接受本协议，在点击之前请再次确认已知悉并完全理解本协议的全部内容。</p>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Navigation from '@/components/about/Navigation.vue';

export default {
  name: 'xieyiCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
    'ui-navigation': Navigation
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.xieyiCenter{
  display: flex;
  div.aa{
    width: 200px;
    margin-right: 30px;
  }
  div.aboutBox{
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 30px;
    h1{
      font-size: 32px;
      color: #FF7B00;
    }
    ul{
      list-style: disc;
      padding-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .xieyiCenter{
    flex-direction: column;
    div.aa{
      margin: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Xieyi.vue